export const SHARED_PROGRESS_PATH = '/shared-progress';

export enum SHARED_ROUTES {
    STUDENT_PROFILE = '/shared-progress/:studentToken',
    STUDENT_OVERALL_PROGRESS = '/shared-progress/:studentToken/overall-progress',
    STUDENT_SIMULATOR_PROGRESS = '/shared-progress/:studentToken/simulator-progress',
    STUDENT_SIMULATOR_PROGRESS_DETAILS = '/shared-progress/:studentToken/simulator-progress/:simulationId',
}
